// src/hooks/useIsMobile.ts
import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 640; // Tailwind sm

const mediaQuery =
  typeof window !== 'undefined'
    ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    : null;

function subscribe(callback: () => void) {
  mediaQuery?.addEventListener('change', callback);
  return () => mediaQuery?.removeEventListener('change', callback);
}

function getSnapshot(): boolean {
  return mediaQuery?.matches ?? false;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
